import { Player } from '@lottiefiles/react-lottie-player';
import { LottieProps } from './Lottie.type';
import SparkSrc from './spark.json';

export default function Sparks({
  className,
  autoplay = true,
  loop = true,
  speed = 1.5,
}: LottieProps) {
  return (
    <Player
      className={className}
      autoplay={autoplay}
      speed={speed}
      loop={loop}
      src={SparkSrc}
      style={{ height: '200px', width: '200px' }}
    />
  );
}
